import { compose } from 'helpers/compose';
import container from './container';
import withTitle from './withTitle';

export default children => compose(container, withTitle)(children);
